import { getAuth } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateExpense from "../../../../Controllers/Admin/Expense/CreateExpense";

import UpdateExpense from "../../../../Controllers/Admin/Expense/UpdateExpense";
import CreateIncome from "../../../../Controllers/Admin/Income/CreateIncome";
import GetSingleIncome from "../../../../Controllers/Admin/Income/GetSingleIncome";
import UpdateIncome from "../../../../Controllers/Admin/Income/UpdateIncome";
import GetAllStudents from "../../../../Controllers/Users/GetAllStudents";

const AddIncomeViewModal = () => {
  const [NewIncome, setNewIncome] = useState({
    Date: "",
    IncomeName: "",
    IncomeAmount: 0,
    IncomeType: "",
  });

  const [IncomeNameError, setIncomeNameError] = useState(false);
  const [IncomeTypeError, setIncomeTypeError] = useState(false);
  const [IncomeDateError, setIncomeDateError] = useState(false);
  const [IncomeAmountError, setIncomeAmountError] = useState(false);
  const [IncomeStudentError, setIncomeStudentError] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [DocId, setDocId] = useState("");
  const [StudentId, setStudentId] = useState("");
  const [AllStudents, setAllStudents] = useState();

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [
    IsCheckError,
    NewIncome.Date,
    NewIncome.IncomeName,
    NewIncome.IncomeAmount,
    NewIncome.IncomeType,
  ]);

  useEffect(() => {
    if (window.location.pathname.includes("update")) {
      setIsUpdate(true);
      const urlParams = new URLSearchParams(window.location.search);
      let UpdateExpenseId = urlParams.get("id");
      setDocId(UpdateExpenseId);

      const fetchData = async () => {
        let resp = await GetSingleIncome(UpdateExpenseId);

        if (resp) {
          setNewIncome({
            Date: resp.Date,
            IncomeName: resp.IncomeName,
            IncomeAmount: resp.IncomeAmount,
            IncomeType: resp.IncomeType,
          });
        }
      };
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let resp = await GetAllStudents();
      if (resp) {
        setAllStudents([...resp]);
      }
    };
    fetchData();
  }, []);

  const navigate = useNavigate();

  const UIErrorHandling = () => {
    let flag = 0;

    if (
      NewIncome.IncomeType === "" ||
      NewIncome.IncomeType === null ||
      NewIncome.IncomeType === undefined
    ) {
      setIncomeTypeError(true);
    } else {
      setIncomeTypeError(false);
    }

    if (NewIncome.IncomeType === "fee") {
      if (StudentId === "" || StudentId === null || StudentId === undefined) {
        setIncomeStudentError(true);
        flag++;
      } else {
        setIncomeStudentError(false);
      }
    }
    if (
      NewIncome.Date === "" ||
      NewIncome.Date === null ||
      NewIncome.Date === undefined
    ) {
      setIncomeDateError(true);
      flag++;
    } else {
      setIncomeDateError(false);
    }
    if (
      NewIncome.IncomeName === "" ||
      NewIncome.IncomeName === null ||
      NewIncome.IncomeName === undefined
    ) {
      setIncomeNameError(true);
      flag++;
    } else {
      setIncomeNameError(false);
    }
    if (
      NewIncome.IncomeAmount === "" ||
      NewIncome.IncomeAmount === null ||
      NewIncome.IncomeAmount < 1 ||
      NewIncome.IncomeAmount === undefined
    ) {
      setIncomeAmountError(true);
      flag++;
    } else {
      setIncomeAmountError(false);
    }
    return flag;
  };

  const AddNewIncome = async (e) => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    let temp = { ...NewIncome };
    if (NewIncome.IncomeType === "fee") {
      temp = {
        ...temp,
        StudentId: StudentId,
      };
    }

    if (flag === 0) {
      setLoader(true);
      if (IsUpdate) {
        let resp = await UpdateIncome(temp, DocId);
        setLoader(false);
        return;
      }

      let resp = await CreateIncome(temp, getAuth().currentUser.uid);
      setLoader(false);
      navigate("/user/admin/income");
    }
  };

  return {
    NewIncome,
    setNewIncome,
    AddNewIncome,
    IncomeNameError,
    IncomeTypeError,
    IncomeDateError,
    IncomeAmountError,
    IsUpdate,
    loader,
    StudentId,
    setStudentId,
    AllStudents,
    setAllStudents,
    IncomeStudentError,
  };
};

export default AddIncomeViewModal;
